"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createKonvaImage;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createKonvaImage(props = {}) {
    const { id = "image", name = "image", image, x, y, width, height, onMouseEnter, onMouseLeave, onMouseMove, onMouseDown, onMouseOver } = props;
    const konvaImage = new _konva.default.Image({
        id,
        name,
        image,
        x,
        y,
        width,
        height
    });
    onMouseEnter && konvaImage.on("mouseenter", onMouseEnter);
    onMouseLeave && konvaImage.on("mouseleave", onMouseLeave);
    onMouseMove && konvaImage.on("mousemove", onMouseMove);
    onMouseDown && konvaImage.on("mousedown", onMouseDown);
    onMouseOver && konvaImage.on("mouseover", onMouseOver);
    return konvaImage;
}
